import { t } from "i18next";
import TooltipWrapper from "common/components/TooltipWrapper/TooltipWrapper";
import { ObservationGroup } from "types/ObservationGroup";

type Props = {
  observationGroups: ObservationGroup[];
  title?: string;
};

function ObservationGroupItem({
  observationGroup,
}: {
  observationGroup: ObservationGroup;
}) {
  return (
    <div className="flex px-2">
      <div className="flex flex-col justify-center flex-1">
        <span className="font-bold text-sm">- {observationGroup?.name}</span>
      </div>
    </div>
  );
}

function ObservationGroupListOverview({ observationGroups, title }: Props) {
  return (
    <div className="flex flex-col flex-1 gap-2">
      <h4 className="text-xl font-bold text-primary leading-4">
        {title ?? t("titlePages.animals")}
      </h4>

      <div>
        <TooltipWrapper
          className="mr-1 my-1"
          content={
            observationGroups?.length > 2 ? (
              <div className="flex flex-wrap gap-2">
                {observationGroups?.map((o: ObservationGroup) => (
                  <ObservationGroupItem observationGroup={o} />
                ))}
              </div>
            ) : null
          }
        >
          <div className="flex flex-wrap gap-2">
            {observationGroups?.map((o: ObservationGroup, index: number) =>
              index < 4 ? <ObservationGroupItem observationGroup={o} /> : null
            )}

            {observationGroups?.length > 4 && (
              <div className="mt-2">
                {t("common.others", {
                  count: (observationGroups?.length || 0) - 4,
                })}
              </div>
            )}
          </div>
        </TooltipWrapper>
      </div>
    </div>
  );
}

export default ObservationGroupListOverview;
